import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);


import zhRouter from "./modules/zh"; //中文
import enRouter from "./modules/en";
import Cookies from 'js-cookie';
// 获取当前站点信息
let currentLanguage = ''; // 假设当前语言是中文
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
import { getCurrSiteData, getcommonData } from "@api/home";

// 
import { getUrlLocale } from '@/utils/url';

const siteDataList = {
  en: '{"tws_id":2,"apply_site":"protal_en"}',
  cn: '{"tws_id":1,"apply_site":"protal"}'
}

getUrlLocaleFun();

async function getUrlLocaleFun(urlPath=null) {
  // 通过url地址栏的参数获取
  let urlLocale = getUrlLocale();
  //检查当前页面是否含是活动，话题，帖子详情页中的一个
  const currentUrl = window.location.pathname;
  console.log(currentUrl);
  var pathsToCheck = [
    '/discuss/info',
    '/subject/info',
    "/activity/info",
    "/challenge/info",
  ];
  // 检查 URL 是否包含 pathsToCheck 数组中的任何路径
  const containsPath = pathsToCheck.some(path => currentUrl.includes(path));

  //这个ip判断的必须放在最前面，需求：在没有cookie的情况下。必须判断ip决定访问中文还是其他语言
  var currCookie = Cookies.get('siteData');
  if (!currCookie && !containsPath) {
    var jumpLang = "cn";
    // 通过接口的ip地址检测
    let res = await getCurrSiteData({ 'isapi': 1 });
    if (res.status == 200) {
      if (res.data.apply_site != 'protal') {
        // 获取当前ip站点信息
        const result = res.data.apply_site.split('_')[1]; // 通过下划线分割并获取第二部分
        currentLanguage = result;
        jumpLang = result;
        Cookies.set('siteData', siteDataList[currentLanguage]);
      } else {
        currentLanguage = 'zh';
        jumpLang = "cn";
        Cookies.set('siteData', siteDataList['cn']);
      }
      localStorage.setItem('currentLanguage', currentLanguage);

      // 定义要检查的字符串数组
      let checkStrings = ['cn', 'en'];
      // 检查是否包含数组中的任何字符串
      let containsTarget = checkStrings.some(str => currentUrl.includes(str));
      if (containsTarget) {
        // 如果包含，进行替换操作
        window.location.href = currentUrl.replace(/(cn|en)/g, jumpLang);
      } else {
        window.location.href = "/";
      }
      if(urlPath!=null){
        window.location.href=urlPath;
      }
      return;
    }
  }
  if (urlLocale) {
    currentLanguage = urlLocale;
    // let langData = await getcommonData();
    // if (langData.status == 200) {
    //   langData.data.lang.forEach(item => {
    //     list.push(item.twss_front_apply_site);
    //   })
    // }
    let list = ["cn", "en"];
    if (!list.includes(currentLanguage)) {
      currentLanguage = 'cn';
    }
    // 点击页面内的连接时有
    // 如果地址栏输入 或者扫码进入新页面 没有
    Cookies.set('siteData', siteDataList[currentLanguage]);
    if (currentLanguage == 'cn') {
      localStorage.setItem('currentLanguage', 'zh');
    } else {
      localStorage.setItem('currentLanguage', currentLanguage);
    }
    if(urlPath!=null){
      window.location.href=urlPath;
    }
    return;
  }
  // 使用本地缓存
  if (Language) {
    currentLanguage = Language;
    if(urlPath!=null){
      window.location.href=urlPath;
    }
    return;
  }

}

// getCurrSiteDatas();
// async function getCurrSiteDatas() {
//   if (Language) {
//     currentLanguage = Language;
//   } else {
//     let res = await getCurrSiteData({ 'isapi': 1 });
//     if (res.status == 200) {
//       if (res.data.apply_site != 'protal') {
//         window.location.href = "/";
//         // 获取当前ip站点信息
//         const result = res.data.apply_site.split('_')[1]; // 通过下划线分割并获取第二部分
//         currentLanguage = result;
//       } else {
//         currentLanguage = 'zh';
//       }
//       localStorage.setItem('currentLanguage', currentLanguage);
//     }
//   }
//   localStorage.setItem('currentLanguage', currentLanguage);
// }

export const constantRoutes = [

  {
    path: "/404",
    name: '404',
    hidden: true,
    component: () => import("@views/error/404"),
  },

  {
    path: "/401",
    name: '401',
    hidden: true,
    component: () => import("@views/error/401"),
  },
  // 中文 路由
  // zhRouter,
  // 英文路由
  // enRouter

  // 活动 active
  // ...enRouter,

  // ...zhRouter,

  ...(currentLanguage == 'en' ? enRouter : zhRouter),

];

/**
 * 动态路由
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  /**
   * 路由模块  
   **/
  ...(currentLanguage == 'en' ? enRouter : zhRouter),
  // ...enRouter,

  // ...zhRouter,

  // 所有页面都未匹配到时
  // { path: "*", hidden: true, redirect: { path: '/' }, },

];

const createRouter = () =>
  new Router({
    mode: 'history', // 需要服务器支持
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// 在路由守卫中更新标题
router.beforeEach(async (to, from, next) => {

  let thisAppName = getUrlLocale(to.fullPath);

  let thisCurrentLang = localStorage.getItem('currentLanguage');
  if (thisAppName == 'cn') {
    if (thisCurrentLang != 'zh') {

      let url = to.fullPath;
      let newUrl = url.replace(/^\/en/, "/cn");
      await getUrlLocaleFun(newUrl);
      return false;
    }
  } else if (thisAppName == 'en'&&thisCurrentLang!='en') {
    let url = to.fullPath;
    let newUrl = url.replace(/^\/cn/, "/en");
    await getUrlLocaleFun(newUrl);
    return false;
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();


});



// 详情见: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // 重置路由器
}

export default router;
